module.exports = __webpack_public_path__ + "img/icona-offerta-prjweb.9d7acc34.png";